import { useIntersection } from '@mantine/hooks'
import { useEffect } from 'react'

type UseInfiniteScrollOptions = {
  hasNextPage: boolean
  isFetchingNextPage: boolean
  fetchNextPage: () => unknown
}

export const useInfiniteScroll = ({
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage
}: UseInfiniteScrollOptions) => {
  const { ref, entry } = useIntersection({
    root: null,
    rootMargin: '200px',
    threshold: 0
  })

  useEffect(() => {
    if (entry?.isIntersecting && hasNextPage && !isFetchingNextPage) {
      void fetchNextPage()
    }
  }, [entry?.isIntersecting, hasNextPage, isFetchingNextPage, fetchNextPage])

  return { ref }
}
